import styled from "styled-components";

export const Container = styled.form`
  width: 300px;
  display: flex;
  flex-direction: column;
  align-items: center;
  select {
    font-size: 18px;
    width: 300px;
    border: none;
    border-bottom: 1px solid var(--secondary-color);
    background-color: transparent;
    margin: 20px 0 10px 0;
  }
  .error {
    transform: translateY(-5px);
    font-size: 1rem;
    color: red;
  }
`;
